import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { CustomerLessonProperties, CustomerLessonPropertiesInit } from "../Account/CustomerLessonProperties";

export interface LessonBuyerInfoInit {
    lessonPropsHolderIs: string[];
    lessonParticipantsAmount: number;
}

class initCustomerProps implements CustomerLessonPropertiesInit {
    parentId: string;
    formElementPrefix: string;

    constructor(parentId: string, formElementPrefix: string) {
        this.parentId = parentId;
        this.formElementPrefix = formElementPrefix;
    }
}

@ModuleName("LessonBuyerInfoModule")
export class LessonBuyerInfoModule implements AxInit {

    private _lessonPropsHolderIs: string[];
    private _customerLessonProps: CustomerLessonProperties[] = [];

    AxInit(lessonBuyerInfoInit: LessonBuyerInfoInit): void {
        this._lessonPropsHolderIs = lessonBuyerInfoInit.lessonPropsHolderIs;

        console.log(lessonBuyerInfoInit.lessonPropsHolderIs);

        for (let i = 0; i < this._lessonPropsHolderIs.length; i++) {

            let id = this._lessonPropsHolderIs[i];
            this.initCustomerPropsDropDowns(id);

            //this._customerLessonProps.push(customerLessonProps);
        }
    }

    initCustomerPropsDropDowns(id: string) {
        let customerLessonProps = new CustomerLessonProperties();
        customerLessonProps.AxInit(new initCustomerProps("#lessonProps_" + id, `ParticipantInfos[${id}].`));
    }
}